news11.vue<template>
<div>
		<sub-header bizCd="10"/>
	 	<div class="sub_visual sub10">
            <div class="container">
                <div class="sub_txt">
                    <div class="tit">보도자료</div>
                    <div class="comment">언론에 소개된 에듀윌의 다양한 소식을 만나보세요.</div>
                </div>
            </div>
        </div>
        <div class="contents aos-all">
            <div class="container">
                <div class="sec">
                    <h3>보도자료</h3>
                    <div class="board">
                        <div class="board_header">
                            <h4>‘에듀윌 공인중개사 합격서’, 판매 즉시 온라인서점 국내도서 전체 베스트셀러 올라</h4>
                            <div class="board_meta">
<!--                                <ul>-->
<!--                                    <li>등록일 : 22.05.24</li>-->
<!--                                    <li>조회수 : 142</li>-->
<!--                                </ul>-->
                            </div>
                        </div>
                      <div class="board_body">
                            <div class="board_content">
                                <figure class="image"><img
                                        src="//img.eduwill.net/resources/b2b/dev/images/img_report_12.png"></figure>
                                <br>
                                <br>
                              종합교육기업 에듀윌이 자사가 출간한 ‘2024 공인중개사 합격서’ 시리즈가 온라인서점 예스24의 수험서 자격증 분야와 함께 국내도서 전체 일별 베스트셀러에도 올랐다고 15일 밝혔다.
                              <br><br>
                              온라인서점 예스24에서 ‘2024 에듀윌 공인중개사 합격서’ 교재가 판매를 시작하자마자 수험서 자격증 분야는 물론 국내도서 일별 베스트셀러에도 이름을 올려 화제다.
                              <br><br>
                              한때 오시훈 부동산공법 합격서 교재는 국내도서 전체 일별 베스트셀러 4위까지 올랐으며, 임선정 공인중개사법령 및 중개실무와 김민석 부동산공시법 그리고 이영방 부동산학개론 합격서 모두 20위권에 입성하며 그 저력을 과시했다.
                              <br><br>
                              베스트셀러 5, 6위를 차지한 토익 교재와 8, 9위에 랭크된 한국사능력검정 교재보다 높은 순위에 공인중개사 교재가 이름을 올렸다. 자격증 취득 시 창업이나 취업으로 바로 연결될 수 있는 국가자격증인 공인중개사 준비에 대한 관심이 여진히 높은 것으로 보인다고 회사 측 전했다.
                              <br><br>
                              합격서 시리즈는 수험서 자격증 분야에서도 독주를 이어갔다. 8일부터 일별 베스트셀러 1위에 오른 오시훈 부동산공법 합격서를 선두로 총 5종이 10위 권에 모두 올랐다.
                              <br><br>
                              '에듀윌 공인중개사 합격서'는 공인중개사 시험 합격을 위해 과목별로 꼭 필요한 핵심 이론을 엄선해 단권화한 교재다. 에듀윌 대표 교수진의 강의를 압축 요약한 것으로 수험생들의 필기 부담을 줄여준다. 모든 학습 단계에 최적인 교재로 기본서 공부를 마친 후 복습용이나 회독용으로 보거나 시험 직전 파이널 교재로 사용하기에도 좋다.
                              <br><br>
                              에듀윌 출판사업본부 관계자는 “수험서 자격증 분야에 이어 국내도서 전체 일별 베스트셀러 상위권에 진입하는 결과에 모두가 놀랐다”면서, “본격 학습을 시작하는 1월을 맞아 앞으로 에듀윌 공인중개사 합격서에 대한 수험생들의 반응은 더욱 좋을 것으로 기대한다”고 말했다.
                            </div>
                        </div>
                        <div class="board_nav">
                            <ul>

                                <!-- 이전 보도 기사가 있을 경우 -->

                              <li class="prev">
                                <router-link to="/edu/newsRelease/promotionVideo/news13" data-value="315283">
                                  <strong>이전</strong>
                                  <span>에듀윌, 케이잡스와 상호 협력 및 파트너십 구축을 위한 업무협약 체결</span>
                                </router-link>
                              </li>

                              <!-- //이전 보도 기사가 있을 경우 -->

                              <!-- 다음 보도 기사가 있을 경우 -->
                              <li class="next">
                                <router-link to="/edu/newsRelease/promotionVideo/news11" data-value="315283">
                                  <strong>다음</strong>
                                  <span>에듀윌, 감정평가사 · 노무사 신규 론칭··· "전문직 자격증 시장에서도 우위 잡을 것"</span>
                                </router-link>
                              </li>
                              <!-- //다음 보도 기사가 있을 경우 -->

                            </ul>
                        </div>
                        <div class="board_footer">
                            <div class="button-area">
                                <router-link to="/edu/newsRelease/main" class="lg-btn">
                                목록으로
                                </router-link>                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import SubHeader from "@/layouts/SubHeader";

export default {
	name: "MainOnlineEdu",
	components: {SubHeader},
	data() {
		return {
			swiper : ""
		}
	},
	
	computed: {
	},
	
	methods: {
	},
	
	created() {
	},
	beforeMount() {
	},
	mounted() {
		AOS.init({ easing: 'ease-in-out-sine' })
		
		this.swiper = new Swiper("#vi-role.swiper-container", {
	        loop: true,
	        loopFillGroupWithBlank: true,
	        navigation: {
	          nextEl: ".swiper-button-next",
	          prevEl: ".swiper-button-prev"
	        }
	    });
		
		$(".pa_slider_scroll").simplyScroll({
	        customClass:'vert',
			speed: 5,
	        pauseOnHover : true
	    });
	},
	beforeDestroy() {
	},
	destroyed() {
	}
}
</script>
